import React from 'react';
import { useNavigate } from 'react-router-dom';
import './_header.scss';
import { useSelector } from 'react-redux';

const TextBackCTA: React.FC = () => {
  const navigate = useNavigate();
  const isWellnessOnly = useSelector((state: any) => state.auth.is_wellness_only);

  if(isWellnessOnly){
    return null;
  }

  return (
    <span
      className="text-back-cta"
      onClick={() => navigate('/dashboard')}
    >
      Back to Dashboard
    </span>
  );
};

export default TextBackCTA;